export interface UIApiConfig {
  APPLICATION_IDENTIFIER: string;
  BASE_API_URL: string;
  DEFAULT_LANGUAGE?: string;
  ORGANIZATION_IDENTIFIER: string;
  REQUEST_PARAMS: {
    headers: {
      Authorization: string;
    };
  };
}
